import React, { useEffect, useState } from "react";

//bayi logosu mobilde sol üst, webde sağ üstte görünür
export default function DealerLogo({ params, isMobile, userId }) {
    const [logoSrc, setLogoSrc] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!params?.company || !userId) return;
        const timestamp = Date.now();
        let imageUrl = `https://api.albertgenauapp.com/files/images/user/${userId}.png?t=${timestamp}`;

        const img = new Image();
        img.onload = () => {
            setLogoSrc(imageUrl);
            setIsVisible(true);
        };
        img.onerror = () => {
            setIsVisible(false);
        };
        img.src = imageUrl;
    }, [params?.company, userId]);

    if (!isVisible || !logoSrc) return null;

    return (
        <div
            style={{
                position: "absolute",
                top: isMobile ? 0 : 5,
                right: isMobile ? null : 5,
                left: isMobile ? 5 : null,
                fontSize: isMobile ? "8px" : "12px",
                zIndex: 10,
                textAlign: "center",
                color: "#000000",
                fontFamily: "sans-serif",
                opacity: 1,
            }}
        ><img
                src={logoSrc}
                style={{
                    height: isMobile ? 35 : 80,
                    objectFit: "contain",
                    marginBottom: 4,
                }}
            />
        </div>
    );
}
